import { AppModel } from "../types/AppModel";

export const ApplicationsInDevelopment: AppModel[] = [{
  name: "RLRPG",
  image: process.env.PUBLIC_URL + "Assets/RLRPG.png",
  description: "RLRPG is a time management app that attempts to gamify the various activities that you do in your day to day life. The more time that you spend doing an activity, the higher the level you will be at that activity. RLRPG also functions as a practice log, allowing you to leave notes after every session of practice. RLRPG is fantastic for helping to build habits and tracking progress. I've enjoyed using it, and maybe one day you will too ;)",
  upVotes: 0,
  downVotes: 0,
  docsLink: ""
}]